/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable import/extensions */
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useConfirm } from 'material-ui-confirm'
import ArchiveIcon from '@material-ui/icons/Archive'

import { remove, archive } from '../AttendanceActions'
import consts from '../../../util/consts'

import GlobalList from './ListTable.jsx'
import { mdiCalendarClock } from '@mdi/js'

import { useHistory, useLocation } from 'react-router-dom'
import { useQueryParams } from '../../../util/utils.js'

function createData(
  id,
  id_laundry_client,
  name,
  laundry_name,
  status,
  value,
  items,
  canRender,
  hasBilling,
  statusId,
  nfseStatus,
  nfseStatusId,
  paymentCompleted,
  userName,
  createdAt,
  userId
) {
  return {
    id,
    id_laundry_client,
    items,
    name,
    laundry_name,
    value,
    userName,
    userId,
    createdAt,
    status,
    nfseStatus,
    nfseStatusId,
    hasBilling,
    statusId,
    update: 'update-attendances',
    delete: 'delete-attendances',
    finance: 'create-billing-client',
    link_update: `/attendance/${id}/edit`,
    link_finance: `/attendance/${id}/payment`,
    canRender,
    paymentCompleted,
  }
}

const headCells = [
  {
    id: 'id',
    numeric: true,
    disablePadding: false,
    label: 'ID',
  },
  {
    id: 'id_laundry_client',
    numeric: true,
    disablePadding: false,
    label: 'Nº OS',
  },
  {
    id: 'items',
    numeric: true,
    disablePadding: false,
    label: 'Itens',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Cliente',
  },
  {
    id: 'laundry_name',
    numeric: false,
    disablePadding: false,
    label: 'Empresa',
  },
  {
    id: 'value',
    numeric: true,
    disablePadding: false,
    label: 'Valor',
    align: 'center',
  },
  {
    id: 'userName',
    numeric: true,
    disablePadding: false,
    label: 'Vendedor',
  },
  {
    id: 'createdAt',
    numeric: true,
    disablePadding: false,
    label: 'Criado Em',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
    align: 'center',
  },
  {
    id: 'nfseStatus',
    numeric: true,
    disablePadding: false,
    label: 'NFSe',
    align: 'center',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Ações',
  },
]

function List(props) {
  const items = useSelector(state => state.attendance.items)

  const dispatch = useDispatch()
  const confirm = useConfirm()

  const sizePerPage = useSelector(state => state.attendance.sizePerPage)
  const page = useSelector(state => state.attendance.page)
  const totalSize = useSelector(state => state.attendance.totalSize)

  const history = useHistory()
  const location = useLocation()

  const filters = useQueryParams(location?.search)

  const rows = []

  items.map(item => {
    return rows.push(
      createData(
        item.id,
        item.id_laundry_client,
        item.client_name,
        item.laundry_name,
        item.status.name,
        item.total_with_discount,
        item.total_items,
        item.can_edit,
        item.has_billing,
        item.status.id,
        item?.nfse_status?.value,
        item?.nfse_status?.var_id,
        item.payment_completed,
        item.user_name,
        item.created_at,
        item.user_id
      )
    )
  })

  const handleChangeRowsPerPage = event => {
    const data = { ...filters, rows: event.target.value, page: 1 }
    handleSubmit(data)
  }

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const onMovePage = (event, newPage) => {
    const data = { ...filters, page: newPage + 1 }
    handleSubmit(data)
  }

  const otherIcons = [
    {
      link: id => ({
        pathname: `/calendar/${id}`,
        search: `?os=${id}`,
        state: { from: `${location.pathname}${location.search}` },
      }),
      ariaLabel: 'calendar',
      completeID: true,
      icon: mdiCalendarClock,
    },
  ]

  const otherIconsClick = [
    {
      onClick: async id => {
        confirm({
          description: 'Deseja arquivar este orçamento?',
          title: 'Tem certeza?',
          confirmationText: 'Sim',
          cancellationText: 'Cancelar',
          dialogProps: {
            fullWidth: true,
          },
        }).then(async () => {
          const resp = await dispatch(archive(id))
          if (resp.status === 200) {
            onMovePage(null, page - 1)
          }
        })
      },
      renderRule: id => {
        return id === consts.ORCAMENTO
      },
      ariaLabel: 'archive',
      icon: <ArchiveIcon />,
    },
  ]

  return (
    <GlobalList
      {...props}
      onMovePage={onMovePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      headCells={headCells}
      rows={rows}
      remove={remove}
      rowsPerPage={sizePerPage}
      page={page - 1}
      totalSize={totalSize}
      otherIcons={otherIcons}
      otherIconsClick={otherIconsClick}
    />
  )
}

export default List
